import { noPreferenceReducedMotion } from '../../functions/reducedMotion';
const boilerplate = () => {
    const expandedButton = document.getElementById('expand-button');
    const collapsibleText = document.getElementById('collapsible-text');
    if (noPreferenceReducedMotion) {
        import('gsap').then(({ gsap }) => {
            const handleExtendAnimated = () => {
                if (!expandedButton || !collapsibleText) {
                    return console.log('Missing expand button or collapsible text element');
                }
                if (expandedButton.innerText.toLowerCase() === 'les mer') {
                    expandedButton.innerText = 'Les mindre';
                    collapsibleText.classList.add('spv-expanded');
                    gsap.to(collapsibleText, { maxHeight: '10000px', duration: 0.5, ease: 'circ.inOut' });
                }
                else {
                    expandedButton.innerText = 'Les mer';
                    collapsibleText.classList.remove('spv-expanded');
                    gsap.to(collapsibleText, { maxHeight: '320px', duration: 0.5, ease: 'circ.inOut' });
                }
            };
            expandedButton?.addEventListener('click', handleExtendAnimated);
        });
    }
    else {
        const handleExtendPlain = () => {
            if (!expandedButton || !collapsibleText) {
                return console.log('Missing expand button or collapsible text element');
            }
            if (expandedButton.innerText.toLowerCase() === 'les mer') {
                expandedButton.innerText = 'Les mindre';
                collapsibleText.classList.add('spv-expanded');
                collapsibleText.style.maxHeight = 'none';
            }
            else {
                expandedButton.innerText = 'Les mer';
                collapsibleText.classList.remove('spv-expanded');
                collapsibleText.style.maxHeight = '320px';
            }
        };
        expandedButton?.addEventListener('click', handleExtendPlain);
    }
};
boilerplate();
export default boilerplate;
//# sourceMappingURL=boilerplate.js.map